var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 mb-10"},[_c('Stats',{attrs:{"title":"Confirmed Bookings","amount":_vm.stats.confirmed}}),_c('Stats',{attrs:{"title":"Unconfirmed Bookings","amount":_vm.stats.pending}}),_c('Stats',{attrs:{"title":"Canceled Bookings","amount":_vm.stats.completed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }